<template>
  <div class="fill-height d-flex flex-column" :style="$vuetify.breakpoint.mdAndDown && ' background: #F6F9FC;'">
    <CheckUserHaveCartSubmittedFlow/>
    <HeaderJourney @goBack="goBack($event)" :state="state"/>
    <div v-if="state == 'select_time' && $vuetify.breakpoint.mdAndDown"></div>
    <SeekBar :current-step="currentStep" v-else/>
    <div class="fill-height " v-if="$vuetify.breakpoint.mdAndUp">
      <v-row class="flex-grow-1 " justify="center">
        <v-col cols="12" md="8" lg="5" class="mt-5">
          <v-fade-transition>
            <!--            <SeekBar :current-step="derivedCurrentStep" v-if="$vuetify.breakpoint.mdAndUp && seekbarVisibility"/>-->

          </v-fade-transition>
        </v-col>
      </v-row>
      <template v-if="state == 'matchMaking'">
        <div class="mt-10">
          <div class="contextArea">

            <v-row class="flex-grow-1 " justify="center" :class="$vuetify.breakpoint.mdAndUp && 'mt-10' ">
              <v-col cols="12" md="8" lg="4">
                <!--              <MatchMaking @excludeUser="excludeUser" @changeStateFlow="changeStateFlow($event)"-->
                <!--                           @setTherapists="setTherapists($event)"-->
                <!--                           @changeStep="changeStep($event)"/>-->
                <MatchMakingTestUserFlow
                    @updateFlowState="updateFlowState"
                    @restartTest="restartTest"
                    @ensureJourneyToken="ensureJourneyToken"
                    :language="$vuetify.rtl ? 'fa' : 'en'"
                    :call-change-in-option="callChangeInOption"
                    @matchMakingTestEnd="matchMakingTestEnd($event)"
                    :prev="prev"
                    :session-token="token"
                    :initial-answer-record="initialAnswerRecord"
                    v-if="initialAnswerRecord"
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </template>
      <template v-else-if="state == 'exclude'">
        <ExcludePage/>
      </template>
      <template v-else-if="state == 'select_time'">
        <SelectedTime :selectd_time="selected_time" @changeStateFlow="changeStateFlow($event)"
                      @selectTime="selectTimeWithOutState($event)"
                      :therapist="selectedTherapist"/>
      </template>
      <template v-else-if="state == 'suggest_doctors'">
        <div :class="$vuetify.breakpoint.mdAndUp && 'mt-10' ">
          <div class="contextArea">
            <v-fade-transition mode="out-in">
              <div key="1" v-if="!therapists">
                <div class="text-center mt-10">
                  <lottie-animation
                      ref="anim"
                      :animationData="require('../../assets/lottie/searching.json')"
                      :loop="true"
                      :autoPlay="true"
                      style="width: 238px;margin: 0px auto"
                  />
                  <div class="titleLoading">
                    در حال یافتن بهترین درمانگران متناسب با شما...
                  </div>
                  <div class="descLoading">
                    تا چند لحظه دیگر، نتیجه بررسی به شما ارائه میشود
                  </div>
                </div>
              </div>
              <SuggestedDoctor key="2" @selectDoctor="selectDoctor($event)" @changeStateFlow="changeStateFlow($event)"
                               v-else-if="therapists.length != 0"
                               :session-token="token"
                               :therapists="therapists"/>
              <SuggestDoctorEmptyState key="3" @changeStateFlow="changeStateFlow($event)" v-else/>
            </v-fade-transition>
          </div>
        </div>
      </template>
      <template v-else-if="state == 'auth'">
        <AuthJourney @getMatchTherapist="getMatchTherapist" @changeStateFlow="changeStateFlow($event)"/>
      </template>
      <template v-else-if="state == 'select_package'">
        <SelectPacakge :flow="flow" v-if="selected_time" @backToTime="backToTime" :selected_time="selected_time"
                       @changeStateFlow="changeStateFlow($event)"
                       @restartTest="restartTest"
                       @selectTime="selectTime($event)"
                       :session-token="token"
                       :therapist="selectedTherapist"/>
      </template>
    </div>
    <div v-else class="mobilecontext">
      <div class="contextArea  fill-height">
        <template v-if="state == 'matchMaking'">
          <div class="contextArea fill-height white ">
            <!--            <MatchMaking @excludeUser="excludeUser" @changeStateFlow="changeStateFlow($event)"-->
            <!--                         @setTherapists="setTherapists($event)"-->
            <!--                         @changeStep="changeStep($event)"/>-->
            <MatchMakingTestUserFlow
                @updateFlowState="updateFlowState"
                @restartTest="restartTest"
                @ensureJourneyToken="ensureJourneyToken"
                :language="$vuetify.rtl ? 'fa' : 'en'"
                :call-change-in-option="callChangeInOption"
                @matchMakingTestEnd="matchMakingTestEnd"
                :prev="prev"
                :session-token="token"
                :initial-answer-record="initialAnswerRecord"
                v-if="initialAnswerRecord"
            />

          </div>
        </template>
        <template v-else-if="state == 'exclude'">
          <ExcludePage/>
        </template>
        <template v-else-if="state == 'select_time'" class="">
          <SelectedTime :selectd_time="selected_time" @changeStateFlow="changeStateFlow($event)"
                        @selectTime="selectTimeWithOutState($event)"
                        :therapist="selectedTherapist"/>
        </template>
        <template v-else-if="state == 'suggest_doctors'">
          <div class="contextArea fill-height white" style="padding-top: 20px">
            <v-fade-transition>
              <template v-if="!therapists">
                <div class="d-flex justify-center flex-column mt-8">
                  <div class="text-center  fill-height ">
                    <lottie-animation
                        ref="anim"
                        :animationData="require('../../assets/lottie/searching.json')"
                        :loop="true"
                        :autoPlay="true"
                        style="width: 238px;margin: 0px auto"
                    />
                    <div class="titleLoading">
                      در حال یافتن بهترین درمانگران متناسب با شما...
                    </div>
                    <div class="descLoading">
                      تا چند لحظه دیگر، نتیجه بررسی به شما ارائه میشود
                    </div>
                  </div>
                </div>
              </template>

              <SuggestedDoctor
                  @selectDoctor="selectDoctor($event)"
                  :selectd_time="selected_time" @changeStateFlow="changeStateFlow($event)"
                  v-else-if="therapists.length != 0"
                  :session-token="token"
                  :therapists="therapists"/>

              <SuggestDoctorEmptyState @changeStateFlow="changeStateFlow($event)" v-else/>
            </v-fade-transition>


          </div>
        </template>
        <template v-else-if="state =='auth'">
          <AuthJourney @getMatchTherapist="getMatchTherapist" @changeStateFlow="changeStateFlow($event)"/>
        </template>
        <template v-else-if="state == 'select_package'">
          <SelectPacakge :flow="flow" v-if="selected_time" @backToTime="backToTime" :selected_time="selected_time"
                         @changeStateFlow="changeStateFlow($event)"
                         @restartTest="restartTest"
                         @selectTime="selectTime($event)"
                         :session-token="token"
                         :therapist="selectedTherapist"/>
        </template>
      </div>
    </div>

    <div class="footerArea" v-if="$vuetify.breakpoint.mdAndUp && state !== 'select_package'">
      <div class="text-center flex-grow-1">
        سیمیاروم برای شرایط اضطراری طراحی نشده است، اگر در بحران هستید، لطفاً از خدمات
        <a style="text-decoration: none"
           href="https://simiaroom.com/%D8%AA%D9%84%D9%81%D9%86-%D9%87%D8%A7%DB%8C-%D8%A7%D9%88%D8%B1%DA%98%D8%A7%D9%86%D8%B3%DB%8C-%D8%AD%D9%88%D8%B2%D9%87-%D8%B3%D9%84%D8%A7%D9%85%D8%AA-%D8%B1%D9%88%D8%A7%D9%86/">
          <span class="greenText font-weight-bold">
          اورژانسی حوزه سلامت روان
        </span>
        </a>
        استفاده
        کنید.
      </div>
    </div>


    <v-dialog v-model="loginModal" width="520" persistent>
      <div class="white loginModal text-center">
        <img src="../../assets/image/user-journey/computer-login-concept-illustration_114360-7892.jpg" width="50%"
             alt="">
        <div class="titleAuthModal">
          تا اینجا عالی پیش رفتید،برای قدم بعدی آماده اید؟
        </div>
        <div class="descAuthModal">
          جهت مشاهده نتیجه تحلیل و معرفی تراپیست های مناسب شما، کافیست وارد شوید
        </div>
        <div class="doneBtn mt-5">
          <v-btn class="nextBtn" color="#30A778" block id="confirm_btn" elevation="0"
                 @click="state = 'auth';loginModal = false">
            ورود و مشاهده درمانگران مناسب من
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
/*eslint-disable*/
import MatchMakingTestUserFlow from "@/components/MatchMaking/MatchMakingTestUserFlow.vue";
import MatchMaking from "@/components/UserJourney/MatchMaking.vue";
import SeekBar from "@/components/UserJourney/SeekBar.vue";
import SuggestedDoctor from "@/components/UserJourney/SuggestedDoctor.vue";
import SelectedTime from "@/components/UserJourney/SelectedTime.vue";
import HeaderJourney from "@/components/UserJourney/HeaderJourney.vue";
import AuthJourney from "@/components/UserJourney/AuthJourney.vue";
import SelectPacakge from "@/components/UserJourney/SelectPacakge.vue";
import SuggestDoctorEmptyState from "@/components/UserJourney/suggestDoctorEmptyState.vue";
import ExcludePage from "@/components/UserJourney/ExcludePage.vue";
import {mapGetters} from "vuex";
import CheckUserHaveCartSubmittedFlow from "@/components/UserJourney/CheckUserHaveCartSubmittedFlow.vue";
import LottieAnimation from "lottie-web-vue";
import PreSessionBox from "@/components/UserJourney/PreSessionBox.vue";
import EventsMixins from "@/mixins/EventsMixins";
import {
  isValidJourneyToken,
  readStoredJourneyToken,
  persistStoredJourneyToken,
  resolveJourneyToken,
  clearJourneyStorage as clearStoredJourneyKeys,
} from "@/utils/journeyToken";

export default {
  mixins: [EventsMixins],
  components: {
    PreSessionBox,
    LottieAnimation,
    CheckUserHaveCartSubmittedFlow,
    MatchMakingTestUserFlow,
    ExcludePage,
    SuggestDoctorEmptyState,
    SelectPacakge, AuthJourney, HeaderJourney, SelectedTime, SuggestedDoctor, SeekBar, MatchMaking
  },
  data() {
    return {
      loginModal: false,
      prev: false,
      match_additional_data: {},
      callChangeInOption: false,
      seekbarVisibility: true,
      state: 'matchMaking',
      currentStep: 1,
      selectedTherapist: {},
      therapists: null,
      token: null,
      startFlowPromise: null,
      should_exclude: false,
      selected_time: null,
      initialAnswerRecord: null,
      timezone: null,
      flow: null,
      journeyBookSent: false, // guard to avoid duplicate journey_book tracking
    }
  },
  computed: {
    ...mapGetters({
      'isLoggedIn': 'getIsLoggedIn',
      'profile': 'getProfile',
    }),
    derivedCurrentStep() {
      if (this.state == 'init' || this.state == 'matchMaking') {
        return 1
      } else if (this.state == 'auth') {
        return 2
      } else if (this.state == 'suggest_doctors') {
        return 3
      }
    }
  },
  methods: {
    matchMakingTestEnd(data) {
      localStorage.removeItem('psychology_field_id')
      this.match_additional_data = data
      this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 80)
      localStorage.setItem('match_additional_data', JSON.stringify(data))
      if (this.isLoggedIn) {
        this.getMatchTherapist();
        this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 85)
      } else {
        // this.loginModal = true
        this.state = 'auth'
      }
    },
    goBack() {
      if (this.state == 'matchMaking') {
        this.$emitEvent('backInMatchMaking')
      } else {
        // Reset flag when going back from select_package
        if (this.state == 'select_package') {
          this.journeyBookSent = false
        }
        let pages = {
          suggest_doctors: 'matchMaking',
          select_time: "suggest_doctors",
          select_package: "select_time",
          auth: "matchMaking",
        }
        this.state = pages[this.state]
      }
    },
    excludeUser() {
      this.state = 'exclude'
      console.log('excludeexcludeexcludeexcludeexclude')
    },
    backToTime() {
      this.journeyBookSent = false // Reset flag when going back to time selection
      this.state = 'select_time'
    },
    selectTime(time) {
      console.log('this. is a ', time)
      this.selected_time = time
      this.state = 'select_package'
    },
    selectTimeWithOutState(time) {
      this.selected_time = time
    },

    selectDoctor(therapist) {
      this.selectedTherapist = therapist
      this.state = 'select_time'
    },
    selectDoctorForWithoutState(therapist) {
      this.selectedTherapist = therapist
    },
    changeStep(step) {
      this.currentStep = step
    },
    returnBack() {
      if (this.currentStep != 1) {
        this.$emitEvent('changeStepMatchmaking', (this.currentStep - 1))
      } else {
        window.location = 'https://simiaroom.com'
      }
    },
    readStoredJourneyToken,
    persistJourneyToken(token) {
      const valid = persistStoredJourneyToken(token)
      if (valid) {
        this.token = valid
      }
      return valid
    },
    getCurrentJourneyToken() {
      return resolveJourneyToken(this.token)
    },
    startFlow() {
      if (this.startFlowPromise) {
        return this.startFlowPromise
      }
      localStorage.removeItem('psychology_field_id')
      this.journeyBookSent = false
      this.startFlowPromise = this.requesting('setSession', 'startFlow', {}, {
        timezone: this.prepareDefaultTimezone()
      }).then((resp) => {
        if (!resp || resp.type === 'FAILURE') {
          throw new Error('startFlow missing token')
        }
        const flow = resp.data && resp.data.flow
        const token = flow && flow.token
        if (!isValidJourneyToken(token)) {
          throw new Error('startFlow missing token')
        }
        this.flow = flow
        this.persistJourneyToken(token)
        if (resp.data.answer_record) {
          this.initialAnswerRecord = resp.data.answer_record
          this.state = 'matchMaking'
        }
        return token
      }).finally(() => {
        this.startFlowPromise = null
      })
      return this.startFlowPromise
    },
    ensureJourneyToken(done) {
      const existing = this.getCurrentJourneyToken()
      const promise = existing
        ? Promise.resolve(this.persistJourneyToken(existing))
        : this.startFlow()
      if (typeof done === 'function') {
        promise.then((token) => done(token)).catch(() => done(null))
      }
      return promise
    },
    changeStateFlow(data) {
      window.scrollTo({top: 0, behavior: 'smooth'});
      data.token = this.getCurrentJourneyToken()
      
      // Reset journeyBookSent flag when leaving select_package state
      if (this.state == 'select_package' && data.state != 'select_package') {
        this.journeyBookSent = false
      }
      
      if (this.state == 'mm_submit' || this.state == 'matchMaking') {
        if (this.$store.getters.getIsLoggedIn) {
          this.state = 'suggest_doctors'
        } else {
          this.state = 'auth'
        }
      } else if (data.state != 'matchMaking' && data.state != 'auth') {
        this.$emitEvent('setLoading', true)
        if (data.state == 'select_package') {
          // Prevent duplicate journey_book event - check and set flag immediately
          if (!this.journeyBookSent) {
            this.journeyBookSent = true
            this.SendEventTrk({
              event_id: 'user_journey_' + Date.now(),
              name: 'journey_book',
              email: this.profile.email,
              first_name: this.profile.firstname,
              last_name: this.profile.lastname,
              payload: {
                data: data,
              }
            })
          }
        }
        this.requesting('setSession', 'changeState', {}, data).then((resp) => {
          if (data.state == 'select_time') {
            this.$emitEvent('setLoading', true)
            let localToken = this.getCurrentJourneyToken()
            this.requesting('setSession', 'getFlowDetail', {}, {
              token: localToken
            }).then((resp) => {
              this.selectDoctor(resp.data.flow.doctor)
            }).catch((error) => {
              if (this.isFlowOwnershipMismatch(error) || (error.response && error.response.status === 400)) {
                this.recoverStaleJourney()
              }
            }).finally(() => {
              setTimeout(() => {
                this.$emitEvent('setLoading', false)
              }, 1000)
            })
          } else {
            this.state = data.state
          }

        }).finally(() => {
          setTimeout(() => {
            this.$emitEvent('setLoading', false)
          }, 1000)
        })
      } else {
        this.state = data.state
      }
    },
    setTherapists(therapists) {
      this.therapists = therapists
      console.log('setted therapist', [this.therapists])
    },
    getMatchTherapist() {
      this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 90)
      // this.match_additional_data = JSON.parse(localStorage.getItem('match_additional_data'))
      const token = this.getCurrentJourneyToken()
      if (!token) {
        this.recoverStaleJourney()
        return
      }
      this.match_additional_data.token = token
      this.match_additional_data.timezone = this.timezone
      console.log(this.match_additional_data)
      if (this.profile.tz == 'UTC' || this.profile.tz != this.timezone) {
        let data = {
          timezone: this.timezone,
        };
        this.requesting('auth', 'editProfile', '', data)
      }

      if (this.match_additional_data) {
        this.state = 'suggest_doctors'
        this.therapists = null
        this.requesting('match_making', 'suggestDoctor', {}, this.match_additional_data).then((resp) => {
          if (resp.message == "exclude") {
            this.$emitEvent('excludeUser')
          } else {
            setTimeout(() => {
              this.setTherapists(resp.data.therapists)
              this.state = 'suggest_doctors'
            }, 2000)
          }
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      }
    },
    restartTest() {
      this.clearJourneyStorage()
      this.journeyBookSent = false // Reset flag when restarting
      setTimeout(() => {
        location.reload();
      }, 500)
    },
    isFlowOwnershipMismatch(error) {
      const status = error && error.response && error.response.status
      const payload = error && error.response && error.response.data
      const errorCode = payload && payload.data && payload.data.error_code
      return status === 403 || errorCode === 'FLOW_OWNERSHIP_MISMATCH'
    },
    clearJourneyStorage() {
      this.token = null
      clearStoredJourneyKeys()
    },
    recoverStaleJourney() {
      this.initialAnswerRecord = null
      this.clearJourneyStorage()
      this.journeyBookSent = false
      this.state = 'matchMaking'
      return this.startFlow()
    },
    updateFlowState() {
      const token = this.getCurrentJourneyToken()
      if (!token) {
        return
      }
      this.requesting('setSession', 'getFlowDetail', {}, {
        token
      }).then((resp) => {
        this.flow = resp.data.flow
      })
    },
    getFlowDetail(token) {
      this.$emitEvent('setLoading', true)

      this.requesting('setSession', 'getFlowDetail', {}, {
        token
      }).then((resp) => {
        const flow = resp.data && resp.data.flow
        if (!flow) {
          return this.startFlow()
        }
        this.flow = flow
        this.persistJourneyToken(flow.token || token)
        this.initialAnswerRecord = resp.data.answer_record
        if (this.$route.query.from == 'googleAuth') {
          this.state = 'auth'
          setTimeout(() => {
            this.$emitEvent('needToCheckMobileAndSubmit')
          }, 300)
          return;
        }
        if (flow.is_expired) {
          console.log('expired')
          this.clearJourneyStorage()
          setTimeout(() => {
            location.reload();
          }, 500)
        } else if (flow.length == 0) {
          this.startFlow()
          this.state = 'matchMaking'
          return;
        }
        if (resp.data.test_status == 'done' && flow.state == 'init') {
          this.state = 'auth'
          return;
        }
        if (resp.data.flow.suggested_doctor) {
          this.therapists = []
          resp.data.flow.suggested_doctor.forEach((item) => {
            this.therapists.push(item.doctor)
          })
        }
        if (flow.state == 'mm_submit') {
          this.state = 'matchMaking'
        } else if (flow.state == 'init') {
          this.state = 'matchMaking'
        } else if (flow.state == 'mm_submit') {
          this.state = 'suggest_doctors'
          let therapists = []
          flow.suggested_doctor.forEach((item) => {
            therapists.push(item.doctor)
          })
          this.setTherapists(therapists)
        } else if (flow.state == 'select_time') {
          this.state = flow.state
          this.selected_time = flow.date_time
          this.selectDoctor(flow.doctor)
        } else if (flow.state == 'select_package') {
          this.selectTime(flow.date_time)
          this.selectDoctorForWithoutState(flow.doctor)
        } else if (flow.state == 'select_doctor') {
          // this.state = 'matchMaking'
          // this.currentStep = 4
          this.selectDoctor(flow.doctor)
        } else {
          this.state = flow.state
        }

      }).catch((error) => {
        if (this.isFlowOwnershipMismatch(error)) {
          this.recoverStaleJourney()
        } else if (error.response && error.response.status === 400) {
          this.clearJourneyStorage();
          location.reload();
        } else {
          console.error('Error:', error);
        }
      }).finally(() => {
        setTimeout(() => {
          this.$emitEvent('setLoading', false)
        }, 1000)
      });
    },
  },
  watch: {
    'state'() {
      let pages = {
        'matchMaking': "matchmaking",
        'auth': "auth",
        'suggest_doctors': "suggested_doctor",
        'select_time': "select_time",
        'select_package': "select_packages"
      }
      window.history.pushState("", "", `?step=${pages[this.state]}`);
    }
  },
  mounted() {


    window.history.pushState("", "", `?step=matchmaking`);

    this.$onEvent('excludeUser', () => {
      this.state = 'exclude'
      this.clearJourneyStorage()
    })


    this.timezone = this.prepareDefaultTimezone()


    this.$onEvent('changeVisibiltySeekback', (status) => {
      this.seekbarVisibility = status
    })

    this.$onEvent('goBack', () => {
      this.goBack()
    })

    this.$onEvent('setTherapists', (therapist) => {
      this.setTherapists(therapist)
    })


    let localToken = this.readStoredJourneyToken()
    if (this.timezone === 'Asia/Tehran') {
      window.location.href = 'https://simiaroom.com/pre-session';
    } else if (localToken) {
      this.persistJourneyToken(localToken)
      this.getFlowDetail(localToken)
    } else {
      this.startFlow()
    }
  }
}
</script>

<style>

@media (min-width: 200px) and (max-width: 800px) {
  .headerArea {
    padding: 0px 20px !important;
    box-shadow: none !important;
    height: 80px !important;;
  }

  .headerArea img {
    width: 58px !important;
  }

  .contextArea {
    background: #F6F9FC;

  }

  .titleLoading {
    font-size: 20px !important;
  }

  .descLoading {
    font-size: 16px !important;
  }

}

.nextBtn {
  height: 50px !important;
  color: white !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  border-radius: 8px;
}


.titleAuthModal {
  font-weight: 700;
  font-size: 18px;
  text-align: center;
}

.descAuthModal {
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  margin-top: 10px;
}

.loginModal {
  padding: 25px 20px;
}

.mobilecontext {
  background: #F6F9FC;
  height: 100%;
  margin-top: -8px;

}


.footerArea {
  border-top: 1px solid #EAF0F6;
  background: #FFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}


.greenText {
  color: #39C990;
}

p[data-f-id="pbf"] {
  display: none !important;
}

.titleLoading {
  font-weight: 700;
  font-size: 24px;
  text-align: center;
}

.descLoading {
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
}

</style>